import React from 'react';
import {
  FieldWrap,
  Form,
  Label,
  LabelInput,
  TextArea,
} from '../../common/components/form';
import { StyledStaticField } from '../../common/components/form/ui';
import Button from '../../../ui/button/Button';

import { Localize } from '../../../locale/localization';


const ProductForm = (props) => {
  const {
    enabled,
    onSubmit,
    onCancel,
    onBlur,
    onInputChange,
    onDescriptionChange,
    errors,
    touchedFields,
    isValid,
    name,
    url,
    description,
    descriptions,
  } = props;

  const productDescriptions = descriptions.map((descItem, index) => {
    const {
      _id, title, description
    } = descItem;
    return (
      <FieldWrap key={_id}>
        <LabelInput
          type="text"
          label="Ohjelmasisältö"
          name={`title-${index}`}
          value={title}
          error={errors[`title-${index}`] && touchedFields.indexOf(`title-${index}`) > -1}
          errorMessage={errors[`title-${index}`]}
          onChange={onDescriptionChange}
        />
        <LabelInput
          type="text"
          label="Sisällön kuvaus"
          name={`description-${index}`}
          value={description}
          error={errors[`description-${index}`] && touchedFields.indexOf(`description-${index}`) > -1}
          errorMessage={errors[`description-${index}`]}
          onChange={onDescriptionChange}
        />
      </FieldWrap>
    );
  });

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      {/*<LabelInput
        type="text"
        label="Nimi"
        name="name"
        value={name}
        error={errors['name'] && touchedFields.indexOf('name') > -1}
        errorMessage={errors['name']}
        onChange={onInputChange}
      />*/}

      <Label label="Nimi">
        <StyledStaticField>{name}</StyledStaticField>
      </Label>

      {productDescriptions}

      <LabelInput
        Component={TextArea}
        rows="4"
        label="Tilausvaihtoehdot"
        name="description"
        value={description}
        error={errors['description'] && touchedFields.indexOf('description') > -1}
        errorMessage={errors['description']}
        onChange={onInputChange}
      />

      <LabelInput
        type="text"
        label="Linkki lisätietoihin"
        name="url"
        value={url}
        error={errors['url'] && touchedFields.indexOf('url') > -1}
        errorMessage={errors['url']}
        onChange={onInputChange}
      />
      
      <footer>
        <Button theme="light" onClick={onCancel}>{Localize('action.cancel')}</Button>
        <Button disabled={!isValid || !enabled} type="submit">{Localize('action.submit')}</Button>
      </footer>
    </Form>
  );
};

export default ProductForm;


// WEBPACK FOOTER //
// ./src/modules/product/components/ProductForm.js